import React from "react";
import { TYPE_PC } from "../../../common/defines";
import { customer_voice } from "../../../common/customer_voice";

export const okugai = ({ type }) => {
  return (
    <div className="tab_panel">
      <div className="characteristic">
        <div className="title">屋外型トランクルームのおススメポイント</div>
        <div className="text">
          ・北海道から九州まで全国展開
          <br />
          ・コンテナ前まで車乗り入れ可能
          <br />
          ・24時間利用可能
          <br />
          ・大容量収納が可能な大型サイズも豊富
          <br />
          ・全国で約60,000室展開
          <br />
        </div>
      </div>
      {type === TYPE_PC ? customer_voice(type, true) : ""}
    </div>
  );
}



// WEBPACK FOOTER //
// ./pages/new/lineup/okugai.jsx